function Parent({message}) {
    return <p>{message}</p>
}

export default Parent;